<div class="scroll-to-top" *ngIf="showComponent" @fade>
  <div class="container">
    <button type="button" (click)="scrollToTop()" class="btn">Scroll To Top</button>
  </div>
</div>
